// extracted by mini-css-extract-plugin
export default {"container":"TimerButton_container__Taraw","text":"TimerButton_text__kMay5","button":"TimerButton_button__k-gcN","timerActive":"TimerButton_timerActive__EkXs+"};